/* ============================================================
   CH TOOLS -- Branded Product Template interactions
   ------------------------------------------------------------
   - Gallery: thumbnail click swaps main image (crossfade)
   - Lightbox zoom on the main image
   - Accordions (one section can be open by default)
   - Quantity stepper
   - Variant selection (updates price / availability / hidden id)
   - Reserve & collect placeholder + share + wishlist
   - Video poster -> embed swap
   ============================================================ */
(function(){
  'use strict';

  function init(root){
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    /* ---------- Gallery ---------- */
    var mainImg = root.querySelector('.chpd__main');
    var thumbs  = Array.prototype.slice.call(root.querySelectorAll('.chpd__thumb'));
    var stage   = root.querySelector('.chpd__stage-inner');

    function selectThumb(t){
      var src = t.getAttribute('data-full') || (t.querySelector('img') && t.querySelector('img').src);
      if (!src || !mainImg) return;
      thumbs.forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
      mainImg.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = function(){
        mainImg.src = src;
        mainImg.alt = t.getAttribute('data-alt') || mainImg.alt;
        requestAnimationFrame(function(){ mainImg.classList.remove('is-swapping'); });
      };
      pre.onerror = function(){ mainImg.classList.remove('is-swapping'); };
      pre.src = src;
    }
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){ selectThumb(t); });
      t.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); selectThumb(t); }
      });
    });

    /* ---------- Lightbox ---------- */
    var lb = root.querySelector('.chpd__lightbox');
    var lbImg = lb && lb.querySelector('img');
    var lbClose = lb && lb.querySelector('.chpd__lightbox-close');
    if (stage && lb && lbImg){
      stage.addEventListener('click', function(){
        lbImg.src = mainImg.src;
        lb.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
      function closeLb(){ lb.classList.remove('is-open'); document.body.style.overflow = ''; }
      lbClose.addEventListener('click', closeLb);
      lb.addEventListener('click', function(e){ if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeLb(); });
    }

    /* ---------- Accordions ---------- */
    /* Height toggle is instant (max-height none/0); the smooth feel comes
       from the inner's opacity/transform transition in CSS. This avoids
       flaky max-height transitions. */
    var accs = Array.prototype.slice.call(root.querySelectorAll('.chpd__acc'));
    accs.forEach(function(acc){
      var btn = acc.querySelector('.chpd__acc-btn');
      if (!btn) return;
      btn.setAttribute('aria-expanded', acc.classList.contains('is-open') ? 'true' : 'false');
      btn.addEventListener('click', function(){
        var open = !acc.classList.contains('is-open');
        acc.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---------- Quantity stepper ---------- */
    var qtyWrap = root.querySelector('.chpd__qty');
    if (qtyWrap){
      var input = qtyWrap.querySelector('input');
      var minus = qtyWrap.querySelector('[data-qty="minus"]');
      var plus  = qtyWrap.querySelector('[data-qty="plus"]');
      function clamp(){
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        input.value = v;
      }
      minus && minus.addEventListener('click', function(){ input.value = Math.max(1, (parseInt(input.value,10)||1) - 1); });
      plus  && plus.addEventListener('click', function(){ input.value = (parseInt(input.value,10)||1) + 1; });
      input && input.addEventListener('change', clamp);
    }

    /* ---------- Variant selection ---------- */
    var variantData = null;
    var dataEl = root.querySelector('[data-variant-json]');
    if (dataEl){
      try { variantData = JSON.parse(dataEl.textContent); } catch(e){ variantData = null; }
    }
    var swatches = Array.prototype.slice.call(root.querySelectorAll('.chpd__swatch'));
    var idInput  = root.querySelector('input[name="id"]');
    var priceEl  = root.querySelector('.chpd__price');
    var selected = {};
    swatches.forEach(function(sw){
      sw.addEventListener('click', function(){
        if (sw.classList.contains('is-soldout')) return;
        var optIndex = sw.getAttribute('data-opt');
        // toggle active within the same option group
        root.querySelectorAll('.chpd__swatch[data-opt="' + optIndex + '"]').forEach(function(x){ x.classList.remove('is-active'); });
        sw.classList.add('is-active');
        selected[optIndex] = sw.getAttribute('data-value');
        applyVariant();
      });
    });
    function applyVariant(){
      if (!variantData) return;
      var want = [];
      Object.keys(selected).sort().forEach(function(k){ want[parseInt(k,10)] = selected[k]; });
      var match = variantData.find(function(v){
        return v.options.every(function(o, i){ return want[i] == null || want[i] === o; });
      });
      if (match){
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price != null) priceEl.textContent = match.price;
      }
    }

    /* ---------- Share ---------- */
    var shareBtn = root.querySelector('[data-share]');
    if (shareBtn){
      shareBtn.addEventListener('click', function(){
        var url = window.location.href;
        var title = (root.querySelector('.chpd__title') || {}).textContent || document.title;
        if (navigator.share){
          navigator.share({ title: title.trim(), url: url }).catch(function(){});
        } else if (navigator.clipboard){
          navigator.clipboard.writeText(url).then(function(){
            shareBtn.classList.add('is-active');
            setTimeout(function(){ shareBtn.classList.remove('is-active'); }, 1400);
          });
        }
      });
    }

    /* ---------- Wishlist (localStorage) ---------- */
    var wishBtn = root.querySelector('[data-wishlist]');
    if (wishBtn){
      var pid = wishBtn.getAttribute('data-product-id') || (root.getAttribute('data-product-handle')) || 'product';
      var KEY = 'ch_wishlist';
      function readList(){ try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ return []; } }
      function isWished(){ return readList().indexOf(pid) !== -1; }
      function paint(){ wishBtn.classList.toggle('is-active', isWished()); }
      paint();
      wishBtn.addEventListener('click', function(){
        var list = readList();
        var i = list.indexOf(pid);
        if (i === -1) list.push(pid); else list.splice(i, 1);
        try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){}
        paint();
      });
    }

    /* ---------- Reserve & collect ---------- */
    var reserveBtn = root.querySelector('[data-reserve]');
    if (reserveBtn){
      reserveBtn.addEventListener('click', function(e){
        var url = reserveBtn.getAttribute('data-reserve-url');
        if (!url || url === '#'){
          // Default: scroll/jump to contact, or alert in preview
          if (reserveBtn.tagName !== 'A'){
            e.preventDefault();
            window.dispatchEvent(new CustomEvent('ch:reserve', { detail: { product: root.getAttribute('data-product-handle') } }));
          }
        }
      });
    }

    /* ---------- Video poster ---------- */
    var poster = root.querySelector('.chpd__video-poster');
    if (poster){
      poster.addEventListener('click', function(){
        var embed = poster.getAttribute('data-embed');
        var holder = poster.parentNode;
        if (embed){
          holder.innerHTML = embed;
        }
      });
    }
  }

  function boot(){ document.querySelectorAll('.chpd').forEach(init); }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector('.chpd');
    if (root) init(root);
  });
})();
